var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{ref:"observe"},[_vm._v(_vm._s(_vm.num)+_vm._s(_vm.suffix))])
}
var staticRenderFns = []

export { render, staticRenderFns }